import { useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import { useCurrentPage } from '»utils/customHooks';

import FinantechBgLoginPage from '../../../assets/img/FINANTECH_bg-login.webp';
import FinantechBgLPage from '../../../assets/img/FINANTECH_bg-lpage.webp';
import { GradientContainer, TextContainer } from '../AppCard.styles';
import {
  BackgroundMobileImageStyled,
  BoxBackgroundImageStyled,
  CardContainer,
  LandingPageText,
  LinkStyled,
} from './AppCardFinantech.styles';

export const AppCardFinantech = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();

  const { isNoAuthFormPage, isLoginPage, isOnboardingAdvancedSteps } =
    useCurrentPage(location.pathname);

  const imageLink =
    'https://br.freepik.com/fotos-gratis/pessoas-de-negocios-na-africa-apertando-as-maos_6213760.htm#query=handshake%20black%20people%20business&position=22&from_view=search&track=ais&uuid=82c9bacc-0649-4a0b-9ddb-cbaf9966d28d';

  if (isDesktop)
    return (
      <BoxBackgroundImageStyled
        isFormPage={isNoAuthFormPage}
        isLoginPage={isLoginPage}
        isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
      >
        <GradientContainer
          isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
        >
          <TextContainer isFormPage={isNoAuthFormPage}>
            <LandingPageText isFormPage={isNoAuthFormPage}>
              <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN" />
            </LandingPageText>
          </TextContainer>
          {isLoginPage && (
            <LinkStyled href={imageLink} target="_blank" rel="noreferrer">
              <FormattedMessage id="TRLT_UI-FREEPIK" />
            </LinkStyled>
          )}
        </GradientContainer>
      </BoxBackgroundImageStyled>
    );

  return (
    <CardContainer isLoginPage={isLoginPage} isFormPage={isNoAuthFormPage}>
      <LandingPageText isFormPage={isNoAuthFormPage}>
        <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN" />
      </LandingPageText>
      <BackgroundMobileImageStyled
        alt="background-mobile-image"
        component="img"
        src={isLoginPage ? FinantechBgLoginPage : FinantechBgLPage}
        isFormPage={isNoAuthFormPage}
      />
      {isLoginPage && (
        <LinkStyled href={imageLink} target="_blank" rel="noreferrer">
          <FormattedMessage id="TRLT_UI-FREEPIK" />
        </LinkStyled>
      )}
    </CardContainer>
  );
};
